<template>
  <footer></footer>
</template>

<script>
export default {
  name: 'comp-footer'
}
</script>

<style lang="scss" scoped src="../scss/CompFooter.scss"></style>



// WEBPACK FOOTER //
// src/components/shared/vue/CompFooter.vue